import Banner from "@/components/Banner";
import type { McpPlaygroundAuthStatus } from "./useMcpPlaygroundAuth";

type McpPlaygroundAuthBannerProps = {
  status: McpPlaygroundAuthStatus;
};

export default function McpPlaygroundAuthBanner({ status }: McpPlaygroundAuthBannerProps) {
  if (status === "loading" || status === "ready") {
    return null;
  }

  if (status === "unauthenticated") {
    return (
      <Banner
        variant="warn"
        testId="mcp-playground-auth-banner"
        description="Sign in with your staff Okta session to use Chat with Member 360. This page uses your existing M360 login — no separate MCP credentials."
      />
    );
  }

  return (
    <Banner
      variant="warn"
      testId="mcp-playground-auth-banner"
      description="Agent chat is not available in this environment yet. Try again after the latest Backoffice release is deployed."
    />
  );
}
